import classes from './Footer.module.scss';
import { FaPhoneAlt } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";


const Footer = () => {
  return (
    <div className={classes.module}>
      <div className={classes.content}>
        <div className={classes.menu}>
          <div className={classes.logo}  onClick={() => window.location.href = '/'}>
            <img width={125} src='/images/logo-dark.png' />
          </div>
          <nav className={classes.nav}>
            <ul className={classes.navList}>
              <li onClick={() => window.location.href = '/'}>Home</li>
              <li onClick={() => window.location.href = '/solutions'}>Solutions & Services</li>
              <li onClick={() => window.location.href = '/pricing'}>Pricing</li>
              <li onClick={() => window.location.href = '/aboutus'}>About Us</li>
              <li onClick={() => window.location.href = '/contactus'}>Contact Us</li>
            </ul>
          </nav>
          <div className={classes.buttons}>
            <button><FaPhoneAlt /></button>
            <button><IoMdMail /></button>
          </div>
        </div>
        <hr />
        <div className={classes.copyright}>
          <span>Copyright © 2025-Implant Genius Enterprises Inc. All Rights Reserved.</span>
        </div>
      </div>
    </div>
  )
}


export default Footer;